import { CircularProgress } from '@mui/material';

export function LoadingIcon({
  size = 'default',
}: {
  size?: 'default' | 'small';
}) {
  return <CircularProgress size={size === 'small' ? '1em' : '0.5em'} />;
}
